import React from 'react';

const Checkbox = ({ checked, onChange, icon = 'check', size = '2rem', theme = 'light' }) => {
  return (
    <div
      className={`border-2 rounded flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500 cursor-pointer ${theme === 'light'
          ? 'bg-white border-gray-400 hover:border-gray-500'
          : 'bg-gray-700 border-gray-600 hover:border-gray-500'
        }`}
      style={{ width: size, height: size }}
    >
      <input
        type="checkbox"
        style={{ width: size, height: size }}
        className="opacity-0 absolute cursor-pointer"
        checked={checked}
        onChange={e => onChange(e.target.checked)}
      />
      <i className={`material-icons fill-current hidden text-sm font-bold cursor-pointer ${theme === 'light' ? 'text-gray-800' : 'text-white'}`}>
        {icon}
      </i>
    </div>
  );
};

export default Checkbox;
